export default {
    computed: {
        imgSize() {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              return "400";
            case "sm":
              return "500";
            case "md":
            case "lg":
            case "xl":
              return "600";
          }
        },
      },
    
    

}